export default {
    section: 'Buyer Information',
    name: 'offer-letter-buyer',
    items: [
        {
            type: 'data-table',
            text: 'Buyer Name',
            name: 'offer-letter-buyer-names',
            props: {
                headers: [
                    {
                        text: 'Buyer',
                        value: 'full-name'
                    }
                ],
                newItemLabel: 'Add A Buyer',
                noDataLabel: 'Please Add a Buyer'
            },
        },
        {
            type: 'text-field',
            text: 'Formal Company Name (if applicable)',
            name: 'offer-letter-buyer-company-name',
            props: {
                label: 'Formal Company Name'
            }
        },
        {
            type: 'selectlist',
            text: 'Entity Type',
            name: 'offer-letter-buyer-entity-type',
            width: 3,
            props: {
                items: [
                    {
                        text: 'swap-entity-types',
                        value: 'swap-entity-types'
                    }
                ]
            }
        },
        {
            type: 'checkbox-list',
            text: 'Purchasing as:',
            name: 'offer-letter-buyer-purchasing',
            props: {
                items: [
                    {
                        text: 'Individual',
                        value: 'individual'
                    },
                    {
                        text: 'company',
                        value: 'company'
                    }
                ]
            }
        }
    ]
};


// WEBPACK FOOTER //
// ./src/components/offer-letter/valuation-data/buyer-information.js